import { render, staticRenderFns } from "./OfferSpaceSelector.vue?vue&type=template&id=7f27afd2&scoped=true"
import script from "./OfferSpaceSelector.vue?vue&type=script&lang=ts"
export * from "./OfferSpaceSelector.vue?vue&type=script&lang=ts"
import style0 from "./OfferSpaceSelector.vue?vue&type=style&index=0&id=7f27afd2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f27afd2",
  null
  
)

export default component.exports